import React from "react";
import { useNavigate} from 'react-router-dom';
import MessageFullWidthBlock from "../../../../modules/afterLogin/MessageFullWidthBlock";
// import { checkCircleFill, closeCircleIcon } from "../../../../constants/icons";
import { closeCircleIcon } from "../../../constants/icons";

const TransferOrdersSuccess = () => {
    const navigate = useNavigate();
    const handleClick = () => {
        navigate('/student-dashboard');
    }
    return (
      <div className="container">
        <MessageFullWidthBlock
            icon={closeCircleIcon}
            title="Self Transfer Failed!"
            message="Oops ! Something went wrong while transfering the Event Subscription."
            buttonText="Back to Subscription!"
            handleButtonClick={handleClick}
        />
      </div>
    );
  }
  
  export default TransferOrdersSuccess;
  